import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React, { FC } from 'react';

interface Props {
  text: string;
}

const HintTooltip: FC<Props> = (props) => {
  const { text } = props;
  return (
    <Tooltip title={text}>
      <InfoCircleOutlined style={style} />
    </Tooltip>
  );
};

const style = { fontSize: '13px' };

export default HintTooltip;
